module.exports = __webpack_public_path__ + "img/bg-top.dbbcb129.png";